export default __webpack_public_path__ + "static/media/faceE-victory.c713a251.png";